import axios from 'axios'

const apiClient = axios.create({
  baseURL: `${process.env.VUE_APP_API_URL}`,
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-type': 'application/json'
  },
  timeout: 10000 //Throw error if API call takes longer than 10 sec//
})

apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.authorization = 'Bearer '+ token;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

export default {
  getExperienceCategories() {
    return apiClient.get('/experienceCategories') //API call that fetch all product categories in json object//
  },
  postExperienceCategory(experienceCategory) {
    return apiClient.post('/experienceCategories', experienceCategory)
  },
  postExperience(experience) {
    return apiClient.post('/experience', experience)
  },
  getExperienceById(id) {
    return apiClient.get('/experience/' + id) // API call to tell server which product to fetch//
  },
  getExperienceCategoryById(id) {
    return apiClient.get('/experienceCategories/' + id) // API call to tell server which product to fetch//
  },
  getExperiences() {
    return apiClient.get('/experiences')
  },
  updateExperienceCategoryById(id, experienceCategory) {
    return apiClient.put('/experienceCategory/' + id, experienceCategory) // API call to tell server which product to fetch//
  },
  getUnitExperiences(id) {
    return apiClient.get('/unitExperiences/' + id)
  },
  postUnitExperience(unitExperience) {
    return apiClient.post('/unitExperiences', unitExperience)
  },
  getUnitExperience(unitId, experienceId) {
    return apiClient.get('/unit/' + unitId + '/experience/' + experienceId)
  },
  updateUnitExperience(unitExperience) {
    return apiClient.put('/unitExperience', unitExperience)
  },
  deleteUnitExperience(unitId, experienceId) {
    return apiClient.delete(`/unitExperiences/unit/${unitId}/experience/${experienceId}`)
  },
  deleteExperienceCategory(id) {
    return apiClient.delete('/experienceCategory/' + id) // API call to tell server which product to fetch//
  },
  deleteExperience(id) {
    return apiClient.delete('/experience/' + id) // API call to tell server which product to fetch//
  },
  searchExperiences(searchTerm) {
    return apiClient.get(`/search/experiences?search=${searchTerm}`) //API call that fetch all products in json object//
  },
  searchUnitExperiences(id, searchTerm) {
    return apiClient.get(`/search/unitExperiences/${id}?search=${searchTerm}`) //API call that fetch all products in json object//
  }
}
